import { render, staticRenderFns } from "./DataTableEmptyFilter.vue?vue&type=template&id=96cd0216&scoped=true&"
import script from "./DataTableEmptyFilter.vue?vue&type=script&lang=js&"
export * from "./DataTableEmptyFilter.vue?vue&type=script&lang=js&"
import style0 from "./DataTableEmptyFilter.vue?vue&type=style&index=0&id=96cd0216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cd0216",
  null
  
)

export default component.exports